import { IntlShape } from 'react-intl'
import { MilestoneCamera } from '@/types/vlm'
import { MILESTONE_MAX_CAMERAS } from '../../vlmPipelineConfig'

export const validateMaxCameras = (
  intl: IntlShape,
  cameras: MilestoneCamera[]
) =>
  cameras.length > MILESTONE_MAX_CAMERAS
    ? intl.formatMessage(
        { id: 'vlm.pipelines.create.cameras.max' },
        { max: MILESTONE_MAX_CAMERAS }
      )
    : null
